import styles from "./Section6.module.scss";

export const Section6 = function () {
  return (
    <section className={`${styles.container} cc--component-container`}>
      <div className={styles.container_wrapper}>
        <h2 className={styles.headline}>Learn on Your Schedule</h2>
        <p>
          This is a <strong>part-time boot camp</strong> designed for working professionals like you who want to learn
          cybersecurity to advance careers, enhance skills for a current role, or change career paths.
        </p>
        <table className={styles.cuCyberTable}>
          <tbody>
            <tr>
              <td className="has-text-align-left">
                <strong>Time to complete</strong>
              </td>
              <td className="has-text-align-center">24 weeks</td>
            </tr>
            <tr>
              <td className="has-text-align-left">
                <strong>Live online classes</strong>
              </td>
              <td className="has-text-align-center">9 hrs/week</td>
            </tr>
            <tr>
              <td className="has-text-align-left">
                <strong>Homework &amp; projects</strong>
              </td>
              <td className="has-text-align-center">&nbsp;20+ hrs/week</td>
            </tr>
            <tr>
              <td className="has-text-align-left">
                <strong>Class time</strong>
              </td>
              <td className="has-text-align-center">
                3 weekday evenings
                <br />
                (3 hrs/class)
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};
